module.exports = __webpack_public_path__ + "img/package_feed.8df75712.svg";